<template>
  <v-toolbar
    flat
    class="cb"
  >
    <div v-if="speaking" class="cb--left">
      <v-btn icon class="cb--btn" @click="toggleMicrophone" :class="microphoneMuted ? 'call--mic-muted' : ''">
        <v-icon>{{microphone}}</v-icon>
      </v-btn>
      <div class="cb--timer">{{timer}}</div>
    </div>
    <div v-else style="width:120px;"></div>

    <v-spacer></v-spacer>
    <div class="cb--title" @click="openCallDetails">{{title}}</div>

    <v-spacer></v-spacer>
    <v-btn icon @click="inviteUsers" v-if="speaking">
      <v-icon>person_add</v-icon>
    </v-btn>
    <v-btn color="green" icon @click="accept" v-else-if="canAccept">
      <v-icon>call</v-icon>
    </v-btn>
    <v-btn color="red" icon @click="decline">
      <v-icon>call_end</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<style lang="scss">
  .cb {
    background-color: var(--call-bar-background) !important;

    &--left {
      align-items: center; 
      display: flex;
      margin-left:-12px !important;
      margin-right:16px;
      width:120px;
    }
    &--timer {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: .02em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;
    }
    &--title {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: .02em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;
      cursor: pointer;
      margin-left:-60px; /* --left.width / 2 */
    }
    &--title:hover {
      color:var(--v-accent-base);
    }
    &--btn {
      padding: 0;
      margin: 8px 0 8px 8px;
    }
  }
</style>

<script>
  import {EventBus} from '@/event-bus'
  import timeUtils from '@utils/timeUtils'

  export default {
    name: 'call-bar',
    data: () => ({
      title: '',
      users: [],
      timer: '00:00',
      speaking: false,
      seconds: 0,
      timerId: 0,
      microphoneMuted: false
    }),
    components: {
    },
    computed: {
      canAccept() {
        return !this.speaking && this.$store.getters.isCallIncoming
      },
      microphone() {
        return this.microphoneMuted ? 'mic_off' : 'mic'
      }
    },
    methods: {
      openCallDetails() {
        EventBus.$emit('call-open-details', this.users)
      },
      inviteUsers(e) {
        // fix issue with auto closing of 'click-outside' event
        e.stopPropagation()
        let contacts = []
        this.users.forEach(item => contacts.push(item.contactId))
        EventBus.$emit('call-invite-users', contacts)
      },
      accept() {
        this.$store.dispatch('acceptCall')
      },
      decline() {
        this.$store.dispatch('declineCall').then(this.conferenceEnded)
      },
      userListChanged(items) {
        this.users = []
        items.forEach(item => {
          const con = this.$store.state.contacts.find(c => c.contactId == item.contactId)
          if (item.name === '#1')
            item.name = this.$t('contacts_echo')

          this.users.push({ 
            name: item.name,
            contactId: item.contactId,
            avatar: con ? con.avatar : '' 
          })
        })

        if (this.users.length > 0) {
          const suffix = this.users.length > 1 ? (' (' + this.users.length + ')') : ''
          this.title = this.users[0].name + suffix
        }

        console.log('userListChanged: ' + JSON.stringify(this.users))
      },
      conferenceStarted() {
        if (!this.speaking) {
          this.speaking = true
          this.timer = '00:00'
          this.seconds = 0
          this.timerId = setInterval(this.updateTime, 1000)
        }
      },
      conferenceEnded() {
        this.speaking = false
        this.microphoneMuted = false
        if (this.timerId != -1)
          clearInterval(this.timerId)
        this.timerId = -1
      },
      updateTime() {
        this.seconds ++
        this.timer = timeUtils.secondsToTime(this.seconds)
      },
      toggleMicrophone() {
        const toggle = !this.microphoneMuted
        this.$store.dispatch('muteMicrophone', toggle).then(mute => {
          this.microphoneMuted = mute
        })
      },
      fetchUsers() {
        this.$store.dispatch('getCallUsers').then(users => {
          this.userListChanged(users)
        })
      }
    },
    mounted() {
      EventBus.$on('conference-started', this.conferenceStarted)
      EventBus.$on('conference-ended', this.conferenceEnded)
      EventBus.$on('user-list-changed', this.userListChanged)

      this.fetchUsers()
    },
    beforeDestroy() {
      EventBus.$off('conference-started')
      EventBus.$off('conference-ended')
      EventBus.$off('user-list-changed')
    }
  }
</script>